export default {
    bodyPic: require('./illustration.png'),
    bodyPicGrey: require('./illustration-grey.svg'),
    infoIcon: require('./info.svg'),
    selfReturn: require('./selfreturn.svg'),
    delivery: require('./delivery.svg'),
    defaultPhoto: require('./placeholder4.svg'),
    expandArrow: require('./expand-arrow.svg'),
    expandArrowPurple: require('./expand-arrow-purple.svg'),
    callIcon: require('./call-icon.svg'),
    infoIconPurple: require('./infoPurple.svg'),
    likeBtn: require('./like-icon.svg'),
    updatedCellular: require('./updated-cellular.svg'),
    phonePurple: require('./call-phone-purple.svg'),
    default: require('./nophoto-icon.svg'),
    deliveryPurple: require('./deliveryPurple.svg'),
    selfReturnPurple: require('./selfReturnPurple.svg'),
    bodyPicPurpleBig: require('./cellular-page-big.svg'),
    bodyPicPurpleMid: require('./cellular-page-mid.svg'),
    bodyPicPurpleSmall: require('./cellular-page-small.svg'),
    disconnect: require('./icon-disconnect.svg'),
    failedCallback: require('./failed-callback.svg'),
    failedCallbackMid: require('./failed-callback-mid.svg'),
    weWantToHelpIcon: require('./icons-manager-support.svg'),
    weWantToHelpIconMid: require('./icons-manager-support-mid.svg')
};